import React from "react";

// Matches the tiny SVG used in `Visit-log-screen-ui/visitlogscreenui.html` for the Audit Log menu item.
const AuditLogIcon = ({ size = 16, color = "#000000" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 0.45 0.45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.225 0.025a0.015 0.015 0 0 0 -0.015 0.015v0.065a0.015 0.015 0 1 0 0.03 0v-0.049a0.17 0.17 0 1 1 -0.144 0.059 0.015 0.015 0 1 0 -0.023 -0.019A0.2 0.2 0 1 0 0.225 0.025m-0.023 0.217L0.127 0.137a0.007 0.007 0 0 1 0.01 -0.01L0.242 0.202a0.029 0.029 0 1 1 -0.04 0.04"
      fill={color}
    />
  </svg>
);

AuditLogIcon.defaultProps = {
  size: 16,
  color: "#000000",
};

export default AuditLogIcon;

